import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change } from 'redux-form';

// Component
import PaymentDetails from './PaymentDetails';
import PaymentForm from './PaymentForm';
import Avatar from '../../Avatar';
import ListCoverPhoto from '../../ListCoverPhoto';

// Helper
import billDetailsHelpers from '../../../helpers/billDetailsHelper';
import messages from '../../../locale/jsonMessages';
import { formatTime } from '../../../helpers/formatting';
import { getDynamicName, getDynamicTitle } from '../../../helpers/GetDynamicItemName/getDynamicName';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { dateFormat } from '../../../config';

import { formatLocalizedPaymentDate } from '../../../helpers/formatLocateDate';
import { dynamicCancellationValue } from '../../../helpers/GetDynamicItemName/dynamicCancellation';
import { toOptionInputs } from '../../../helpers/bookingOptionsPresentation';
//Image
import steeringIcon from '/public/SiteIcons/steeringIcon.svg';
import arrowIcon from '/public/SiteIcons/paymentArrow.svg';
import starIcon from '/public/SiteIcons/star.svg';
import Arrow from '/public/siteImages/rightSideArrow.svg';

import cs from '../../commonStyle.css';
import s from './Payment.css';

class Payment extends Component {

  static propTypes = {
    listId: PropTypes.number.isRequired,
    hostId: PropTypes.string.isRequired,
    guestId: PropTypes.string.isRequired,
    guestEmail: PropTypes.string.isRequired,
    hostDisplayName: PropTypes.string.isRequired,
    hostPicture: PropTypes.string,
    coverPhoto: PropTypes.string,
    listTitle: PropTypes.string.isRequired,
    allowedPersonCapacity: PropTypes.number.isRequired,
    listType: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    houseRules: PropTypes.arrayOf(PropTypes.shape({
      listsettings: PropTypes.shape({
        itemName: PropTypes.string.isRequired
      })
    })),
    checkIn: PropTypes.object.isRequired,
    checkOut: PropTypes.object.isRequired,
    guests: PropTypes.number.isRequired,
    basePrice: PropTypes.number.isRequired,
    options: PropTypes.array,
    removedOptionsCount: PropTypes.number,
    currency: PropTypes.string.isRequired,
    weeklyDiscount: PropTypes.number,
    monthlyDiscount: PropTypes.number,
    listPhotos: PropTypes.array,
    serviceFees: PropTypes.shape({
      guest: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired
      }).isRequired,
      host: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    base: PropTypes.string.isRequired,
    rates: PropTypes.object.isRequired,
    bookingType: PropTypes.string.isRequired,
    policyName: PropTypes.string.isRequired,
    formatMessage: PropTypes.any,
    reviewsCount: PropTypes.number.isRequired,
    reviewsStarRating: PropTypes.number.isRequired,
  };

  removePromo = () => {
    const { change } = this.props;

    change('PaymentForm', 'promoId', null);
    change('PaymentForm', 'promoValue', 0);
    change('PaymentForm', 'promoCode', null);
    change('PaymentForm', 'promoDiscount', 0);
    change('PaymentForm', 'deductionType', 0);
    change('PaymentForm', 'description', null);
    change('PaymentForm', 'editPayment', false);
    change('PaymentForm', 'dynamicPromoCode', null);
    change('BookingForm', 'promoId', null);
    change('BookingForm', 'promoValue', 0);
    change('BookingForm', 'promoCode', null);
    change('BookingForm', 'promoDiscount', 0);
    change('BookingForm', 'deductionType', 0);
    change('BookingForm', 'description', null);
    change('BookingForm', 'dynamicPromoCode', null);
  }

  getBillDetailsData = (props = this.props) => {
    const {
      specialPricing, serviceFees, monthlyDiscount, weeklyDiscount, base, rates, currency,
      startTime, endTime, checkIn, checkOut, basePrice, options, securityDeposit,
      securityDepositStatus, promoValue, deductionType, getInquiryData
    } = props;
    const { formatMessage } = props.intl;

    let pricingData;

    if (getInquiryData) {
      pricingData = {
        securityDeposit: getInquiryData?.securityDeposit,
      };
    }

    const securityDepositAmount = securityDepositStatus == 1 ? (pricingData ? pricingData?.securityDeposit : securityDeposit) : 0;

    return billDetailsHelpers({
      specialPricing, serviceFees, monthlyDiscount, weeklyDiscount, base, rates, currency,
      startTime, endTime, startDate: checkIn, endDate: checkOut,
      // Options are never part of a pre-approved booking (D13).
      basePrice, options: getInquiryData ? [] : options, securityDeposit: securityDepositAmount,
      discountForMonth: formatMessage(messages.monthlyDiscount),
      discountForWeek: formatMessage(messages.weeklyDiscount),
      promoValue, deductionType
    });
  }

  componentDidUpdate(prevProps) {
    const previousBillDetails = this.getBillDetailsData(prevProps);
    const currentBillDetails = this.getBillDetailsData(this.props);

    if (!previousBillDetails.discountPromoError && currentBillDetails.discountPromoError) {
      this.removePromo();
      showToaster({ toasterType: 'error', messageId: 'promoCodeCalculation' });
    }
  }

  render() {
    const { guestEmail, hostDisplayName, hostPicture, coverPhoto, listPhotos, bookingType, policyName, policyContent, policyId } = this.props;
    const { listId, listTitle, allowedPersonCapacity, hostProfileId, hostJoined, transmission, settingsData } = this.props;
    const { houseRules, hostId, guestId, securityDeposit, securityDepositStatus } = this.props;
    const { guests, checkIn, checkOut, startTime, endTime, threadId, locale, dynamicLanguageData } = this.props;
    const { formatMessage } = this.props.intl;
    const { basePrice, currency, weeklyDiscount, monthlyDiscount, removedOptionsCount } = this.props;
    const { serviceFees, base, rates, specialPricing, bookingData, reviewsCount, reviewsStarRating, dynamicTitle } = this.props;
    const { promoId, promoCode, promoValue, description, deductionType, editPayment, dynamicPromoCode } = this.props;
    const { change, getInquiryData } = this.props;

    let formattedStartTime, formattedEndTime, starRatingValue = 0, totalWithoutFees = 0, isHostServiceEligible, dynamicListTitle;
    let carType = getDynamicName({ value: settingsData[0]?.listsettings, locale, data: dynamicLanguageData }), transmissionLabel;
    dynamicListTitle = getDynamicTitle({ data: dynamicTitle, locale, id: listId });
    carType = carType?.itemName
    transmission == '1' ? transmissionLabel = formatMessage(messages.automatic) : transmissionLabel = formatMessage(messages.manual);

    let pricingData, pricingTotal;

    if (getInquiryData) {
      pricingData = {
        discountType: getInquiryData?.discountType,
        discount: getInquiryData?.discount,
        guestServiceFee: getInquiryData?.guestServiceFee,
        hostServiceFee: getInquiryData?.hostServiceFee,
        total: getInquiryData?.total,
        dayDifference: getInquiryData?.dayDifference,
        isSpecialPriceAssigned: getInquiryData?.isSpecialPriceAssigned,
        startTime: getInquiryData?.startTime,
        endTime: getInquiryData?.endTime,
        securityDeposit: getInquiryData?.securityDeposit,
        isAverage: getInquiryData?.averagePrice,
        priceForDays: getInquiryData?.basePrice,
        currency: getInquiryData?.currency
      };
    }

    let securityDepositAmount = securityDepositStatus == 1 ? (pricingData ? pricingData?.securityDeposit : securityDeposit) : 0;
    let {
      discountType, isAverage, isDayTotal, discount, serviceFee: guestServiceFee,
      hostServiceFee, total, dayDifference, isSpecialPriceAssigned, priceForDays, bookingSpecialPricing, promoDiscount, optionsTotal,
      options: optionLines
    } = this.getBillDetailsData();

    totalWithoutFees = (priceForDays + (optionsTotal || 0)) - discount - promoDiscount;
    pricingTotal = pricingData?.total;

    if (pricingData) {
      promoDiscount = Number(pricingData?.priceForDays) * Number(promoValue) / 100;
      totalWithoutFees = promoDiscount ? pricingData?.priceForDays - discount - promoDiscount : pricingData?.priceForDays - discount;
      pricingTotal = promoDiscount ? pricingTotal - promoDiscount : pricingTotal;
    }

    // The host fee must stay below the rental plus the options (D27).
    isHostServiceEligible = hostServiceFee >= priceForDays + (optionsTotal || 0) ? false : true;

    let checkInDate = checkIn ? formatLocalizedPaymentDate(checkIn, locale, dateFormat?.displayDateFormat) : '';
    let checkOutDate = checkOut ? formatLocalizedPaymentDate(checkOut, locale, dateFormat?.displayDateFormat) : '';

    change('PaymentForm', 'listId', listId);
    change('PaymentForm', 'listTitle', listTitle);
    change('PaymentForm', 'hostId', hostId);
    change('PaymentForm', 'guestId', guestId);
    change('PaymentForm', 'bookingType', bookingType);
    change('PaymentForm', 'paymentType', '2');
    change('PaymentForm', 'guestEmail', guestEmail);
    change('PaymentForm', 'currency', currency);
    change('PaymentForm', 'threadId', threadId);
    change('PaymentForm', 'promoId', promoId);
    change('PaymentForm', 'promoValue', promoValue);
    change('PaymentForm', 'promoCode', promoCode);
    change('PaymentForm', 'description', description);
    change('PaymentForm', 'deductionType', deductionType);
    change('PaymentForm', 'dynamicPromoCode', dynamicPromoCode);

    if (!editPayment || editPayment == undefined) {

      change('PaymentForm', 'guests', guests);
      change('PaymentForm', 'checkIn', checkIn);
      change('PaymentForm', 'checkOut', checkOut);
      change('PaymentForm', 'basePrice', pricingData ? pricingData?.isAverage : basePrice);
      // Ids and delivery location only (JSON string like bookingSpecialPricing): prices are computed by the server.
      change('PaymentForm', 'optionsPayload', JSON.stringify(toOptionInputs(optionLines)));
      change('PaymentForm', 'discount', pricingData ? pricingData?.discount : discount);
      change('PaymentForm', 'discountType', discountType || pricingData?.discountType);
      change('PaymentForm', 'guestServiceFee', pricingData ? pricingData?.guestServiceFee : guestServiceFee);
      change('PaymentForm', 'hostServiceFee', pricingData ? pricingData?.hostServiceFee : hostServiceFee);
      change('PaymentForm', 'hostServiceFeeType', serviceFees?.host?.type);
      change('PaymentForm', 'hostServiceFeeValue', serviceFees?.host?.value);
      change('PaymentForm', 'total', totalWithoutFees);
      change('PaymentForm', 'isSpecialPriceAssigned', pricingData ? pricingData?.isSpecialPriceAssigned : isSpecialPriceAssigned);
      change('PaymentForm', 'bookingSpecialPricing', JSON.stringify(bookingSpecialPricing));
      change('PaymentForm', 'isSpecialPriceAverage', isAverage.toFixed(2));
      change('PaymentForm', 'dayDifference', pricingData ? pricingData?.dayDifference : dayDifference);
      change('PaymentForm', 'startTime', startTime);
      change('PaymentForm', 'endTime', endTime);
      change('PaymentForm', 'securityDeposit', securityDepositAmount);
      change('PaymentForm', 'isHostServiceEligible', isHostServiceEligible);
      change('PaymentForm', 'guestServiceFeeType', serviceFees?.guest?.type);
      change('PaymentForm', 'guestServiceFeeValue', serviceFees?.guest?.value);
      change('PaymentForm', 'promoDiscount', promoDiscount);

    }


    formattedStartTime = formatTime(startTime);
    formattedEndTime = formatTime(endTime);

    if (reviewsCount > 0 && reviewsStarRating > 0) {
      starRatingValue = Math.round(reviewsStarRating / reviewsCount)
    }

    return (
      <Grid fluid className={s.container}>
        <Row className={cx(cs.positionRelative, cs.displayFlex, s.paymentFlexDirection, cs.alignItemFlexStart)}>
          <Col lg={7} md={7} sm={12} xs={12} className={cx(cs.spaceTop7, 'paymentDetailsPadding')}>
            <PaymentForm
              hostDisplayName={hostDisplayName}
              houseRules={houseRules}
              allowedPersonCapacity={allowedPersonCapacity}
              listId={listId}
              hostPicture={hostPicture}
              hostProfileId={hostProfileId}
              hostJoined={hostJoined}
            />
          </Col>
          <Col lg={5} md={5} sm={12} xs={12} className={cx(cs.spaceTop7, cs.paymentSticky)}>
            <div className={s.datePanelSection}>
              <div className={cx(cs.positionRelative, cs.spaceBottom3)}>
                <a href={"/cars/" + listId} target={"_blank"}>
                  <ListCoverPhoto
                    className={cx(s.bannerImage, s.backgroundCover)}
                    coverPhoto={coverPhoto}
                    listPhotos={listPhotos}
                    photoType={"x_medium"}
                    bgImage
                  />
                </a>
                <div className={cx(cs.positionAvatar, 'positionAvatarRTL')}>
                  <Avatar
                    source={hostPicture}
                    title={hostDisplayName}
                    profileId={hostProfileId}
                    className={cx(cs.profileAvatarLink, cs.profileAvatarLinkSmall)}
                    width={44}
                    height={44}
                    withLink
                  />
                </div>
              </div>
              <div className={cx(s.houseRules, cs.spaceTop3)}>
                <img src={steeringIcon} className={'commonIconSpace'} />
                <h6 className={cx(cs.commonSmallText, cs.fontWeightNormal)}>
                  <span>{carType}</span>
                  <span className={cs.dotCss}></span>
                  <span>{transmissionLabel}</span>
                </h6>
              </div>
              {/* <a href={"/cars/" + listId} target={"_blank"} className={cx(cs.spaceTop1, cs.commonContentText, cs.fontWeightBold, cs.siteLinkColor)}>
                {listTitle}
              </a> */}
              <div className={cx(cs.spaceTop1, cs.commonContentText, cs.fontWeightBold)}>
                {dynamicListTitle || listTitle}
              </div>
              {starRatingValue > 0 && <div className={cx(cs.spaceTop1, cs.commonContentText, s.starFlex)}>
                <img src={starIcon} className={'searchHeaderIcon'} /> <span>{starRatingValue}</span>
              </div>}
              <hr className={cx(s.horizondalLine, s.hrLineSidePanelMargin)} />
              <div className={s.tableFlex}>
                <div>
                  <h4 className={cx(cs.commonSmallText, cs.fontWeightNormal, cs.paddingBottom1)}><FormattedMessage {...messages.checkIn} /></h4>
                  <h5 className={cx(cs.commonContentText, cs.fontWeightNormal, cs.siteLinkColor, cs.paddingBottom1)}>{checkInDate}</h5>
                  {
                    formattedStartTime &&
                    <h6 className={cx(cs.commonContentText, cs.fontWeightNormal, cs.siteLinkColor)}>{formattedStartTime}</h6>
                  }
                </div>
                <img src={arrowIcon} className={cx(s.arrowMargin, 'commonDateArrowRTLRotate')} />
                <div>
                  <h5 className={cx(cs.commonSmallText, cs.fontWeightNormal, cs.paddingBottom1)}><FormattedMessage {...messages.checkOut} /></h5>
                  <h4 className={cx(cs.commonContentText, cs.fontWeightNormal, cs.siteLinkColor, cs.paddingBottom1)}>{checkOutDate}</h4>
                  {
                    formattedEndTime &&
                    <h6 className={cx(cs.commonContentText, cs.fontWeightNormal, cs.siteLinkColor)}> {formattedEndTime}</h6>
                  }
                </div>
              </div>
              <hr className={cx(s.horizondalLine, s.hrLineSidePanelMargin)} />
              <PaymentDetails
                basePrice={basePrice}
                options={pricingData ? [] : optionLines}
                securityDeposit={pricingData ? pricingData?.securityDeposit : securityDeposit}
                currency={pricingData ? pricingData?.currency : currency}
                dayDifference={pricingData ? pricingData?.dayDifference : dayDifference}
                priceForDays={pricingData ? pricingData?.priceForDays : priceForDays}
                discount={pricingData ? pricingData?.discount : discount}
                discountType={discountType || pricingData?.discountType}
                serviceFees={pricingData ? pricingData?.guestServiceFee : guestServiceFee}
                total={pricingData ? pricingTotal : total}
                bookingSpecialPricing={bookingSpecialPricing}
                isSpecialPriceAssigned={pricingData ? pricingData?.isSpecialPriceAssigned : isSpecialPriceAssigned}
                isAverage={pricingData ? pricingData?.isAverage : isAverage}
                securityDepositStatus={securityDepositStatus}
                promoDiscount={promoDiscount}
                promoCode={promoCode}
                description={description}
                dynamicPromoCode={dynamicPromoCode}
              />
              {pricingData && (
                <p className={cx(cs.commonSmallText, cs.spaceTop2)} role="note">
                  <FormattedMessage {...messages.boPreApprovedUnavailable} />
                </p>
              )}
              {!pricingData && removedOptionsCount > 0 && (
                <p className={cx(cs.commonSmallText, cs.spaceTop2, 'errorMessageText')} role="alert">
                  <FormattedMessage {...messages.boOptionsRemoved} />
                </p>
              )}
            </div>
            <div className={cx(s.cancellationSectionPayment, cs.spaceTop4, cs.spaceBottom4)}>
              <p className={cx(cs.commonSubTitleText, cs.fontWeightBold, cs.paddingBottom3)}>
                <span><FormattedMessage {...messages.cancellationPolicy} /></span>
                :   <a
                  href={`/cancellation-policies/${policyName}`} className={cs.siteLinkColor}
                  target={'_blank'}
                ><span>
                    {dynamicCancellationValue(policyId)?.name ? (
                      <FormattedMessage {...messages[dynamicCancellationValue(policyId).name]} />
                    ) : (
                      policyName
                    )}
                  </span></a>
              </p>
              <p className={cx(cs.commonContentText, cs.paddingBottom2)}>
                {dynamicCancellationValue(policyId)?.content ? (
                  <FormattedMessage {...messages[dynamicCancellationValue(policyId).content]} />
                ) : (
                  policyContent
                )}
              </p>
              <a
                href={`/cancellation-policies/${policyName}`}
                target={'_blank'}
                className={cx(cs.commonContentText, cs.siteLinkColor, cs.fontWeightMedium, cs.commonLinkBorderBottom, cs.textDecorationNone)}
              >
                <FormattedMessage {...messages.viewDetails} />
                <img src={Arrow} className={cx(cs.blueLeftArrow, 'loginArrowRTL')} />
              </a>
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapState = (state) => ({
  locale: state?.intl?.locale,
  dynamicLanguageData: state?.dynamicListSettings?.data,
  dynamicTitle: state?.dynamicListTitles?.data?.dynamicListTitle,
  getInquiryData: state?.book?.bookDetails?.getInquiry
});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(Payment)));
